import { Rating } from 'react-simple-star-rating';

interface IAcademiaRating {
  isReadonly?: boolean;
  size: number;
  ratingValue: number | null;
  extraClassNames?: string;
}

const AcademiaRating = ({
  size,
  ratingValue,
  isReadonly,
  extraClassNames,
}: IAcademiaRating) => {
  // rendering custom rating component here
  return (
    <div className={`flex items-end gap-1 ${extraClassNames}`}>
      <Rating
        SVGclassName='inline'
        size={size}
        initialValue={ratingValue || 5}
        readonly={isReadonly}
        allowFraction={isReadonly}
      />

      <p className='text-sm font-medium text-base-orange'>
        {ratingValue || 5}
        <span className='text-xs text-base-dark-green'>/5</span>
      </p>
    </div>
  );
};

export default AcademiaRating;
